import Antd from "ant-design-vue"
import Alert from "./Alert"
import Dialog from "./Dialog"

export default [Antd, Alert, Dialog]
